export { default as NavMenu } from './src/navmenu.vue';
